// extracted by mini-css-extract-plugin
export default {"summary":"Collapse_summary__GWw2C","btn":"Collapse_btn__KTuuP"};